import { Popup } from '@syncfusion/ej2-popups';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { EventHandler, detach, addClass } from '@syncfusion/ej2-base';

class FindReplace {
  static rootElement;

  constructor(target, parent) {
    this.target = target;
    this.parent = parent;
    this.render();
  }

  render() {
    FindReplace.rootElement = document.createElement('div');
    FindReplace.rootElement.innerHTML = `
      <div id="find_replace">
        <div id="align" style="margin: 10px;">
          <div class="e-dlg-header" style="padding-bottom:10px;">Find and Replace</div>   
          <label>Find in text</label>
          <input class="e-input" id="findText" />

          <br />
          <br />
          <label>Replace with</label>
          <input class="e-input" id="replaceText" />
          <br />
          <br />
          <input id="checked" type="checkbox" />
          <br />
          <br />
          <br />
          <button class="e-btn e-flat e-primary" id="find">Find</button>
          <button class="e-btn e-flat" id="replace">Replace</button>
          <button class="e-btn e-flat" id="replaceAll">Replace All</button>
          <br/>
          <br/>
          <button class="e-btn e-flat" id="close">Close</button>
        </div>
      </div>`;
    document.body.appendChild(FindReplace.rootElement);
    this.popupObj = new Popup(FindReplace.rootElement, {
      targetType: 'relative',
      relateTo: this.target,
      collision: { X: 'fit', Y: 'none' },
      offsetY: 8,
      position: { X: 'left', Y: 'bottom' },
      zIndex: 10001,
      close: () => {
        this.destroy();
        this.popupObj.destroy();
        detach(this.popupObj.element);
        this.popupObj = null;
      },
    });
    addClass([this.popupObj.element], ['e-popup-open', 'e-rte-emojipicker-popup']);
    this.popupObj.refreshPosition(
      document.getElementsByClassName('e-rte-inline-popup')[0]
    );
    document.getElementById('find_replace').parentElement.style.left = '200px';
    document.getElementById('find_replace').parentElement.style.top = '600px';
    this.bindEvents();
    this.checkBoxObj = new CheckBox({
      label: 'Match case',
      checked: false,
    });
    this.checkBoxObj.appendTo('#checked');
  }

  bindEvents() {
    EventHandler.add(
      FindReplace.rootElement.querySelector('#find'),
      'click',
      this.findHandler.bind(this)
    );
    EventHandler.add(
      FindReplace.rootElement.querySelector('#replaceAll'),
      'click',
      this.replaceAllHandler.bind(this)
    );
    EventHandler.add(
      FindReplace.rootElement.querySelector('#replace'),
      'click',
      this.replaceHandler.bind(this)
    );
    EventHandler.add(
      FindReplace.rootElement.querySelector('#close'),
      'click',
      this.closeHandler.bind(this)
    );
  }

  closeHandler() {
    let content = this.findContent();
    content = content.replace(/<span class="highlight">|<\/span>/gi, '');
    this.parent.inputElement.innerHTML = content;
    this.popupObj.hide();
  }

  findHandler() {
    let searchText = FindReplace.rootElement.querySelector('#findText').value;
    let content = this.findContent();
    if (searchText !== '') {
      if (this.checkBoxObj.checked) {
        content = content.replace(/<span class="highlight">|<\/span>/g, '');
        content = content.replace(
          new RegExp(searchText, 'g'),
          (match) => `<span class="highlight">${match}</span>`
        );
      } else {
        content = content.replace(/<span class="highlight">|<\/span>/gi, '');
        content = content.replace(
          new RegExp(searchText, 'gi'),
          (match) => `<span class="highlight">${match}</span>`
        );
      }

      this.parent.inputElement.innerHTML = content;
    }
  }

  replaceAllHandler() {
    let content = this.findContent();
    let searchText = FindReplace.rootElement.querySelector('#findText').value;
    let replaceText = FindReplace.rootElement.querySelector('#replaceText').value;
    if (searchText !== '' && replaceText !== '') {
      if (this.checkBoxObj.checked) {
        content = content.replace(/<span class="highlight">|<\/span>/g, '');
        const replacedContent = content.replace(
          new RegExp(searchText, 'g'),
          replaceText
        );
        this.parent.inputElement.innerHTML = replacedContent;
      } else {
        content = content.replace(/<span class="highlight">|<\/span>/gi, '');
        const replacedContent = content.replace(
          new RegExp(searchText, 'gi'),
          replaceText
        );
        this.parent.inputElement.innerHTML = replacedContent;
      }
    }
  }

  replaceHandler() {
    let content = this.findContent();
    let searchText = FindReplace.rootElement.querySelector('#findText').value;
    let replaceText = FindReplace.rootElement.querySelector('#replaceText').value;
    if (searchText !== '' && replaceText !== '') {
      const matches = content.match(new RegExp(searchText, 'gi'));

      if (matches && matches.length > 0) {
        content = content.replace(
          new RegExp(`(${searchText})`, 'i'),
          '<span class="highlight">$1</span>'
        );
      }
      let currentIndex = 0;
      if (matches && matches.length > 0) {
        const currentMatch = matches[currentIndex];
        content = content.replace(new RegExp(currentMatch, 'i'), replaceText);

        this.parent.inputElement.innerHTML = content;

        currentIndex++;
        if (currentIndex < matches.length) {
          this.parent.inputElement.innerHTML = content.replace(
            new RegExp(`(${searchText})`, 'i'),
            '<span class="highlight">$1</span>'
          );
        } else {
          currentIndex = 0;
          matches.length = 0;
        }
      }
    }
  }

  findContent() {
    return this.parent.inputElement.innerHTML;
  }

  destroy() {
    EventHandler.remove(
      FindReplace.rootElement.querySelector('#find'),
      'click',
      this.findHandler
    );
    EventHandler.remove(
      FindReplace.rootElement.querySelector('#replaceAll'),
      'click',
      this.replaceAllHandler
    );
    EventHandler.remove(
      FindReplace.rootElement.querySelector('#replace'),
      'click',
      this.replaceHandler
    );
  }
}

export { FindReplace };